import { ReactNode } from "react";

interface LayoutProps {
  children: ReactNode;
  fullWidth?: boolean;
}

export default function Layout({ children, fullWidth = false }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col dark bg-gradient-to-br from-gray-900 to-slate-800 grid-pattern">
      <main className={`flex-1 ${fullWidth ? '' : 'container mx-auto px-4'} py-4 transition-all duration-300`}>
        {children}
      </main>
      <footer className="py-6 px-4 bg-black/20 backdrop-blur-sm border-t border-gray-800">
        <div className="container mx-auto text-center text-sm text-gray-400">
          <p>Truth Nexus Globe AI © {new Date().getFullYear()} - Combating misinformation with technology</p>
        </div>
      </footer>
    </div>
  );
}
